var map = {
	"./boatRouteScene.ts": [
		4647,
		647
	],
	"./cityShowoffScene.ts": [
		2395,
		395
	],
	"./demoScene.ts": [
		7007,
		7
	],
	"./demoSceneSecond.ts": [
		1180,
		180
	],
	"./innRouteScene.ts": [
		9875,
		875
	],
	"./summerSolsticeScene.ts": [
		2233,
		233
	],
	"./tuftFinishedScene.ts": [
		4365,
		365
	],
	"./wolgastDrinkingScene.ts": [
		8073,
		73
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4205;
module.exports = webpackAsyncContext;